import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { ElMessage } from 'element-plus';
import type { HttpResponse } from '@/apis/request';

/**
 * 限制登录态失效提示，一次只提示一次
 */
let showNotLoginDialogFlag = false;

/**
 * 登录态拦截器
 */
export default {
  // 请求拦截器
  request: [
    (config: InternalAxiosRequestConfig) => {
      return config;
    },
    (error: any) => {
      // do something
      return Promise.reject(error);
    },
  ],
  // 响应拦截器
  response: [
    (response: AxiosResponse<HttpResponse>) => {
      const data = response.data;

      // todo 登录态失效,不同项目登录态失效的errorCode不同
      if (data.errorCode === '401' && !showNotLoginDialogFlag) {
        // 登录态失效
        showNotLoginDialogFlag = true;
        // 弹出登录框
        ElMessage.warning('登录态失效，请重新登录！');

        setTimeout(() => {
          // todo 跳转cas登录,不同项目处理方式不同，建议后端返回跳转cas的地址，通过target设置登录成功后的页面
          // @ts-ignore
          window.location.href = `${data.obj.urlToRedirectTo}?target=${window.location.href}`;
        }, 1000);
      }
      return response;
    },
    (error: any) => {
      // 超出 2xx 范围的状态码都会触发该函数。
      // 对响应错误做点什么

      return Promise.reject(error);
    },
  ],
};
